export enum BillingModel {
  RATE_CARD = 'Rate Card',
  PERCENT_OF_MEDIA = 'Percent of Media',
}
